import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NormalizedHorizontalBarChartData } from '@shared/utils/chart-types';
import { ColorsGraphArray } from '@shared/utils/colors-graph';
import { BarHorizontalStackedComponent } from '@swimlane/ngx-charts';

@Component({
  selector: 'app-horizontal-bar-stacked',
  templateUrl: './horizontal-bar-stacked.component.html'
})
export class HorizontalBarStackedComponent implements AfterViewInit {

  @ViewChild('containerRef') containerRef!: ElementRef;
  @ViewChild('chart') chartComponent: BarHorizontalStackedComponent;
  @Input() data: NormalizedHorizontalBarChartData[] = [];
  @Input() label: string = '';
  @Input() view: any[] = [600, 300];
  @Input() showXAxis = true;
  @Input() showYAxis = true;
  @Input() gradient = false;
  @Input() showLegend = true;
  @Input() legendPosition: string = 'right';
  @Input() legendTitle: string = '';
  @Input() customTooltip: boolean = false;
  @Input() tooltipLabel: string = '';
  @Input() isDouble: boolean = true;
  @Input() showXAxisLabel = true;
  @Input() xAxisLabel : string = '';
  @Input() showYAxisLabel = true;
  @Input() yAxisLabel: string = '';
  @Input() animations: boolean = true;
  @Input() showMessageDataIsEmpty = true;
  @Input() barPadding: number;
  @Input() maxYAxisTickLength: number;
  @Input() trimYAxisTicks: boolean = false;
  @Input() colorScheme = {
    domain: [...ColorsGraphArray]
  };

  constructor() {
    Object.assign(this.data);
  }

  get dataIsEmpty(): boolean {
    return this.data?.every((x) => x.series.every((serie) => serie.value === 0));
  }

  get showEmptyChart(){
    if (!this.showMessageDataIsEmpty){
      return true;
    }
    if (this.dataIsEmpty){
      return false;
    }
    return true;
  }

  resizeChart(width: any): void {
    this.view = [width, 300]
  }

  ngAfterViewInit(): void {
    this.formatDataLabels();
  }

  onData(event: any): void {
    this.formatDataLabels();
  }

  formatDataLabels(): void {
    if (this.chartComponent?.['chartElement']) {
      const dataLabelElements = this.chartComponent['chartElement'].nativeElement.querySelectorAll('.textDataLabel');
      dataLabelElements.forEach((labelElement: SVGTextElement, index: number) => {
        if (this.data && this.data[index] && this.data[index].porcentagem) {
          labelElement.textContent = this.data[index].porcentagem;
        }
      });
    }
  }
}
